import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './beforeEach'
import afterEach from './afterEach'

Vue.use(Router)

const router =  new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import("@/layouts/default.vue"),
      children: []
    }
  ]
})

router.beforeEach(beforeEach);
router.afterEach(afterEach);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js